<template>
	<b-list-group flush>
		<b-list-group-item>
			<p class="lead">Race</p>
			<ul class="list-inline mb-0">
				<li class="list-inline-item" v-for="(ability, abilityIndex) in Character.Bio.Race.Properties" :key="abilityIndex">
					<b-link @click="showDetails({title:ability.Name,content:ability.Description})">{{ability.Name}}</b-link>
				</li>
			</ul>
		</b-list-group-item>

		<b-list-group-item>
			<p class="lead">Theme</p>
			<ul class="list-inline mb-0">
				<li class="list-inline-item" v-for="(levelData, level) in previousLevels" :key="level">
					<b-link v-if="levelData.Theme !== undefined" @click="showDetails({title:levelData.Theme.Name,content:levelData.Theme.Description})">{{levelData.Theme.Name}}</b-link>
				</li>
			</ul>
		</b-list-group-item>

		<b-list-group-item>
			<p class="lead">Feats</p>
			<ul class="list-inline mb-0" v-for="(levelData, level) in previousLevels" :key="level">
				<li class="list-inline-item" v-if="levelData.Feats.length > 0"><strong>{{level|ordinal}}</strong></li>
				<li class="list-inline-item" v-for="(feat, index) in levelData.Feats" :key="index">
					<b-link @click="showDetails({title:feat.Name,content:feat.Description})">{{feat.Name}}</b-link>
				</li>
			</ul>
		</b-list-group-item>

		<b-list-group-item>
			<p class="lead">Class</p>
			<ul class="list-inline mb-0" v-for="(levelData, level) in previousLevels" :key="level">
				<li class="list-inline-item" v-if="levelData.Abilities.length > 0"><strong>{{level|ordinal}}</strong></li>
				<li class="list-inline-item" v-for="(ability, abilityIndex) in levelData.Abilities" :key="abilityIndex">
					<b-link @click="showDetails({title:ability.Name,content:ability.Description})">{{ability.Name}}</b-link>
				</li>
			</ul>
		</b-list-group-item>
	</b-list-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	methods: {
		...mapActions('modals', [
			'showDetails',
			'hideDetails'
		]),
	},
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters([
			'previousLevels',
		])
	}
}
</script>

<style scoped>

</style>